<template>
  <VModal
    v-if="isOpened"
    title="Please Confirm"
    size="small"
    :actions="actions"
    extraBackdropClass="confirm-modal"
    @close="$emit('close')"
  >
    <p class="v-confirm-modal">
      <slot> {{ text }} </slot>
    </p>
  </VModal>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VModal from "@/components/VModal";

export default Vue.component("VConfirmModal", {
  props: {
    isOpened: VueTypes.bool.def(false),
    text: VueTypes.string,
    titles: VueTypes.shape({
      primary: VueTypes.string,
      secondary: VueTypes.string
    }).def({})
  },

  components: {
    VModal
  },

  data() {
    return {
      actions: [
        {
          label: this.titles.secondary || "Cancel",
          value: "cancel",
          type: "secondary",
          size: "regular",
          click: () => this.$emit("cancel"),
          extraClass: "secondary-confirm"
        },
        {
          label: this.titles.primary || "Delete",
          value: "add",
          size: "regular",
          click: () => this.$emit("approve"),
          extraClass: "primary-confirm"
        }
      ]
    };
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-confirm-modal";

.#{$ns} {
  font-size: 15px;
  font-family: "Lato-Regular", Arial, Helvetica, "sans-serif";
  text-align: center;
}
</style>

<style lang="scss">
.v-confirm-modal {
  span {
    color: $primary-color;
  }
}

.v-modal__backdrop.confirm-modal {
  background: rgba(31, 31, 31, 0.76);

  #vm-container {
    background: #ffffff;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    border: transparent;
    width: 470px;
    height: 270px;
    padding: 30px;

    .v-modal__header {
      padding: 0;
      margin-bottom: 13px;
      color: $primary-text-color;
      text-align: center;
      background: transparent;
      font-family: Lato-Bold, sans-serif;

      h2 {
        height: 38px;
        font-size: 32px;
      }
    }

    .v-modal__body {
      padding-top: 0;

      p {
        font-family: Lato-Light, sans-serif;
        color: $secondary-text-color;
        font-size: 18px;
        line-height: 25px;
      }
    }

    .v-modal__actions {
      padding: 0;
      border-top: none;
      min-height: 0;
    }
  }
}

.primary.sm.primary-confirm,
.secondary.regular.secondary-confirm {
  height: $input-height;
}

.primary.regular.primary-confirm {
  width: 210px;
  background: $danger-color;
  border: 1px solid transparent;

  &:hover {
    background-color: darken($danger-color, 10%);
    border: inherit;
  }
}

.secondary.regular.secondary-confirm {
  background: transparent;
  border: none;
  color: lighten($primary-color, 10%);

  &:hover {
    color: $primary-color;
    background: transparent;
    border: none;
  }
}
</style>
